import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CopyToClipboardService {

  constructor() { }

  copy(copyText: string): void {
    const copyElement = document.createElement('input');
    copyElement.value = copyText;
    document.body.appendChild(copyElement); // חייב להיות בדף!
  
    copyElement.select();
    copyElement.setSelectionRange(0, 99999); // לתמיכה במובייל
  
    try {
      const successful = document.execCommand('copy');
      if (!successful) {
        throw new Error('Copy command was unsuccessful');
      }
    } catch (err) {
      console.error('Fallback: Unable to copy', err);
    }
  
    document.body.removeChild(copyElement); // ניקוי האלמנט אחרי ההעתקה
  }
}
